import { useTranslations } from '@aikoa/i18n/react'
import { Label } from '@rn-primitives/dropdown-menu'
import { View } from 'react-native'
import Icon from '~/components/Icon'
import { Label as ContentLabel, Detail } from '~/components/typography/Content'
import { cn } from '~/lib/utils'

export function LeadVerificationBadge({ label }: { label?: string | false }) {
  const { t } = useTranslations('leads')

  const defaultLabel = label === undefined ? t(($) => $.verification.verified) : label

  return (
    <View
      className={cn(
        'flex-row gap-1.5 rounded-full',
        defaultLabel && 'bg-neutral-100 px-2 py-1 pr-3 pt-2',
        !defaultLabel && 'size-6 items-center justify-center pl-0.5 pt-1'
      )}>
      <Icon name="shield-check" size={defaultLabel ? 16 : 14} className="text-green-700" />
      {defaultLabel && (
        <Label className="font-medium text-xs uppercase text-green-700">{defaultLabel}</Label>
      )}
    </View>
  )
}

export function InactiveBadge() {
  const { t } = useTranslations('leads')

  return (
    <View className="flex-row items-center gap-1.5 rounded-full bg-destructive/10 px-2 py-1 pr-3 pt-2">
      <Icon name="ban" size={14} className="text-destructive" />
      <Label className="font-medium text-xs uppercase text-destructive">
        {t(($) => $.badges.inactive)}
      </Label>
    </View>
  )
}

export function PurchasedBadge({ variant = 'default' }: { variant?: 'default' | 'compact' }) {
  const { t } = useTranslations('leads')
  const purchasedLabel = t(($) => $.badges.purchased)
  if (variant === 'compact') {
    return (
      <View className="rounded-full bg-accent px-2 py-0.5">
        <Detail className="font-medium text-xs text-accent-foreground">{purchasedLabel}</Detail>
      </View>
    )
  }

  return (
    <View className="flex-row items-center gap-1.5 rounded-full bg-accent px-3 py-1">
      <ContentLabel className="font-medium text-xs uppercase text-accent-foreground">
        {purchasedLabel}
      </ContentLabel>
    </View>
  )
}
